// extracted by mini-css-extract-plugin
export default {"navbar":"Layout_navbar__dN889","dashboard":"Layout_dashboard__gNsA9","mainContent":"Layout_mainContent__EndXy","noScroll":"Layout_noScroll__dx8lX","footer":"Layout_footer__OdQ1Z"};